import {Injectable} from '@angular/core';
import 'rxjs/add/operator/withLatestFrom';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import * as formActions from './subform.actions';
import * as fromSubform from './subform.reducer';
import {FormService} from '../services/form.service';
import {Actions, Effect} from '@ngrx/effects';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class SubformEffects {

    @Effect()
    getAll: Observable<Action> = this.actions.ofType(formActions.LOAD_ALL)
        //.do(console.log)
        // .withLatestFrom(this.state)
        // .filter(arr => arr[1].entities === fromSubform.initialState.entities)
        .switchMap(() => this.service.getAllSubforms())
        .map(forms => new formActions.LoadAllSuccess(forms))
        // .catch(err => new formActions.LoadAllFail(err));

    @Effect()
    create: Observable<Action> = this.actions.ofType(formActions.CREATE)
        .switchMap((a: formActions.Create) => this.service.create(a.form))
        .map(form => new formActions.CreateSuccess(form));

    @Effect()
    update: Observable<Action> = this.actions.ofType(formActions.UPDATE)
        .switchMap((a: formActions.Update) => this.service.update(a.form))
        .map(options => new formActions.UpdateSuccess(options.id, options));

    @Effect()
    delete: Observable<Action> = this.actions.ofType(formActions.DELETE)
        .switchMap((a: formActions.Delete) => this.service.delete(a.id))
        .map(id => new formActions.DeleteSuccess(id));


    constructor(
        private actions: Actions,
        private service: FormService
    ) { }

}



// WEBPACK FOOTER //
// ./src/app/forms/state/subform.effects.ts